import React, { useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { Tabs } from '@roo/roo'
import styles from './index.module.less'
import HighlightText from '../HighlightText'
import Container from '../Container'
import { picUrl } from '@/common/utils/consts'
import { isZh } from '@/common/utils/i18nFuncs'
import SelectedSvg from '../Icons/SelectedSvg'
import { getDangerHtmlText } from '@/common/utils'

interface TabItem {
  key: string;
  title: string;
  beforeContent: [string][];
  afterContent: [string][];
}

const Demo: React.FC = () => {
  const { t } = useTranslation()

  const tabItems: TabItem[] = [
    {
      key: 'admin',
      title: t('ent_o_role_admin', '行政'),
      beforeContent: [
        [
          t('ent_o_role_admin_before_content1'),
        ],
        [
          t('ent_o_role_admin_before_content2'),
        ],
        [
          t('ent_o_role_admin_before_content3'),
        ],
        [
          t('ent_o_role_admin_before_content4'),
        ],
      ],
      afterContent: [
        [
          t('ent_o_role_admin_after_content1'),
        ],
        [
          t('ent_o_role_admin_after_content2'),
        ],
        [
          t('ent_o_role_admin_after_content3'),
        ],
        [
          t('ent_o_role_admin_after_content4'),
        ],
      ],
    },
    {
      key: 'finance',
      title: t('ent_o_role_finance_teams', '财务'),
      beforeContent: [
        [
          t('ent_o_role_finance_teams_before_content1'),
        ],
        [
          t('ent_o_role_finance_teams_before_content2'),
        ],
        [
          t('ent_o_role_finance_teams_before_content3'),
        ],
        [
          t('ent_o_role_finance_teams_before_content4'),
        ],
      ],
      afterContent: [
        [
          t('ent_o_role_finance_teams_after_content1'),
        ],
        [
          t('ent_o_role_finance_teams_after_content2'),
        ],
        [
          t('ent_o_role_finance_teams_after_content3'),
        ],
        [
          t('ent_o_role_finance_teams_after_content4'),
        ],
      ],
    },
    {
      key: 'manager',
      title: t('ent_o_role_manager', '管理者'),
      beforeContent: [
        [
          t('ent_o_role_maneger_before_content1'),
        ],
        [
          t('ent_o_role_maneger_before_content2'),
        ],
        [
          t('ent_o_role_maneger_before_content3'),
        ],
        [
          t('ent_o_role_maneger_before_content4'),
        ],
      ],
      afterContent: [
        [
          t('ent_o_role_maneger_after_content1'),
        ],
        [
          t('ent_o_role_maneger_after_content2'),
        ],
        [
          t('ent_o_role_maneger_after_content3'),
        ],
        [
          t('ent_o_role_maneger_after_content4'),
        ],
      ],
    },
    {
      key: 'employee',
      title: t('ent_o_role_employee', '员工'),
      beforeContent: [
        [
          t('ent_o_role_emplyee_before_content1'),
        ],
        [
          t('ent_o_role_emplyee_before_content2'),
        ],
        [
          t('ent_o_role_emplyee_before_content3'),
        ],
        [
          t('ent_o_role_emplyee_before_content4'),
        ],
      ],
      afterContent: [
        [
          t('ent_o_role_emplyee_after_content1'),
        ],
        [
          t('ent_o_role_emplyee_after_content2'),
        ],
        [
          t('ent_o_role_emplyee_after_content3'),
        ],
        [
          t('ent_o_role_emplyee_after_content4'),
        ],
      ],
    },
  ]


  return (
    <Container>
      <div className={styles.container}>
        <div >
          <h2 className="section-title">
            <span>{t('ent_o_title_full_process1', '助力全流程')}</span>
            <HighlightText textPosition="right">{t('ent_o_title_role_experience1', '各角色提升体验')}</HighlightText>
          </h2>
        </div>
        <Tabs className={styles.tabs} type="line" >
          {tabItems.map(item => (
            <Tabs.Pane name={item.key} label={item.title}>
              <div className={styles.contentWrapper}>
                <div className={styles.beforeAfterContainer}>
                  <div className={styles.beforeContent} style={{ backgroundImage: `url(${isZh() ? picUrl.before : picUrl.beforeEn})` }}>
                    <div className={styles.listWraper} >
                      <div className={styles.list}>
                        {item.beforeContent.map((text, index) => (
                          <div key={index} className={styles.item}>
                            <div dangerouslySetInnerHTML={getDangerHtmlText(text[0]?.replace('、', '<div class="break-word"></div>'))} />
                            {/* <div>{text[1]}</div> */}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={styles.afterContent} style={{ backgroundImage: `url(${isZh() ? picUrl.after : picUrl.afterEn})` }}>
                    <div className={styles.listWraper} >
                      <div className={styles.list} >
                        {item.afterContent.map((text, index) => (
                          <div key={index} className={styles.item}>
                            <div style={{ display: 'flex' }}>
                              <div style={{ paddingTop: '0.8rem' }}>
                                <SelectedSvg style={{ width: '4rem', height: '4rem' }} />
                              </div>
                              <div style={{ flex: 1, paddingLeft: '2rem' }}>
                                <div > {text[0]} </div>
                                <div>{text[1]}</div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={styles.afterBorder} style={{ backgroundImage: `url(${picUrl.afterBorder})` }}></div>
                </div>
              </div>
            </Tabs.Pane>
          ))}
        </Tabs>
      </div>
    </Container>
  )
}

export default Demo
